var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgShiftKey = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 40,
    viewBox: "0 0 65 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.798.666h-54.6c-2.512 0-4.55 2.09-4.55 4.667v29.333c0 2.577 2.038 4.667 4.55 4.667h54.6c2.513 0 4.55-2.09 4.55-4.667V5.333c0-2.578-2.037-4.667-4.55-4.667Z",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.132 3.41H7.872c-1.256 0-2.274 1.045-2.274 2.333v26.462c0 1.289 1.018 2.333 2.275 2.333h49.26c1.256 0 2.274-1.044 2.274-2.333V5.743c0-1.288-1.018-2.333-2.275-2.333Z",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.799 8-7.506 13.333h15.011L20.8 8Zm1.3 21.333V20h-2.6v9.333h2.6Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 40,
    fill: "#fff"
  })))));
};
export { SvgShiftKey as ReactComponent };